import { styled } from 'styled-components';

import { Button } from 'components/Button';

import CustomModal from 'components/CustomModal';

const Description = styled.p`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%;
  letter-spacing: 0.15px;
  margin-bottom: 0px;
`;

const RedirectModal: React.FC<{
  openModal: boolean;
  submissionNoun: string;
}> = ({ openModal, submissionNoun }): React.ReactElement => (
  <CustomModal
    openModal={openModal}
    submitButton={
      <Button
        size="large"
        color="primary"
        variant="contained"
        onClick={() => {
          window.location.reload();
        }}
      >
        Refresh now
      </Button>
    }
    modalTitle={`The ${submissionNoun} template has been updated`}
    modalWidth="sm"
  >
    <Description>
      Your progress has been saved, but you must refresh the page to continue with the latest version. After refreshing,
      you will return to the beginning of the {submissionNoun}.
    </Description>
  </CustomModal>
);

export default RedirectModal;
